import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  modal: {
    //marginTop: theme.spacing(10),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '60%',
    //paddingBottom: theme.spacing(30),
  },
  logo: {
    margin: theme.spacing(1),
  },
  title: {
    //marginTop: theme.spacing(0.5),
    fontSize: 20,
    color: 'black',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 15,
    width: '30%',
  },
  text: {
    //margin: '0 0 24px',
    margin: theme.spacing(1),
    fontSize: 15,
    color: 'black',
  },
  link: {
    fontSize: 20,
    color: 'BLUE',
  },
}));
